// src/Components/Contatti.js
import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import HeaderPattern from "../Components/Common/HeaderPattern";
import "./Styles/ContattiStyles.css";
const redGradient = "linear-gradient(90deg, #e3764c 0%, #99191b 100%)";

export default function Contatti() {
    const pageRef = useRef(null);
    const [mapOpen, setMapOpen] = useState(false);
    const { t } = useTranslation();
    const address = t('contacts.addressFull');
    const mapSrc = `https://www.google.com/maps?q=${encodeURIComponent(address)}&output=embed`;

    return (
        <div ref={pageRef} className="contatti-container">
            <Box
                sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: { xs: "center", sm: "flex-end" },
                    pr: { xs: 2, sm: 6 },
                    position: "relative",
                    right: { xs: 0, sm: 80, md: 200 },
                    pt: { xs: 6, sm: 10, md: 14 },
                    pb: 2,
                }}
            >
                <h1 className="contatti-title">{t('contacts.title')}</h1>
            </Box>

            <Box
                className="esi-transition-header"
                sx={{
                    width: "100%",
                    minHeight: { xs: 180, sm: 240, md: 300 },
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    alignItems: "center",
                    borderBottom: "2px solid #fff",
                    background: redGradient,
                    overflow: "hidden",
                }}
            >
                <Box
                    sx={{
                        flex: { xs: "none", sm: "0 0 45%", md: "0 0 60%" },
                        display: { xs: "none", sm: "flex" },
                        alignItems: "center",
                        justifyContent: "flex-start",
                        height: "100%",
                    }}
                >
                    <HeaderPattern
                        style={{
                            width: "100%",
                            height: "300px",
                            maxHeight: "300px",
                            overflow: "visible",
                            transform: "scale(1.3) translateX(-10%)",
                            transformOrigin: "left center",
                            userSelect: "none",
                            pointerEvents: "none",
                        }}
                    />
                </Box>

                <Box
                    sx={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: { xs: "center", sm: "flex-end" },
                        justifyContent: "center",
                        pr: { xs: 2, sm: 6 },
                        pl: { xs: 2, sm: 0 },
                        py: { xs: 3, sm: 0 },
                        position: "relative",
                        right: { xs: 0, sm: 80, md: 200 },
                        gap: 0.5,
                    }}
                >
                    <div className="contatti-info">
                        <p className="contatti-indirizzo">{t('contacts.addressCity')}</p>
                        <p>{t('contacts.addressStreet')}</p>
                        <p>{t('contacts.addressPostal')}</p>
                        <br/>
                        <p>{t('contacts.phone')}</p>
                        <p><a href={`mailto:${t('contacts.email')}`} className="contatti-link">{t('contacts.email')}</a></p>
                        <p><a href={`mailto:${t('contacts.pec')}`} className="contatti-link">{t('contacts.pec')}</a></p>
                        <p>{t('contacts.vatLabel')}</p>
                        <br/>
                        <p className="vedi-mappa" onClick={() => setMapOpen(true)}>{t('contacts.viewMap')}</p>
                    </div>
                </Box>
            </Box>

            {/* Social icons */}
            <Box
                sx={{
                    display: "flex",
                    justifyContent: { xs: "center", sm: "flex-end" },
                    gap: "12px",
                    padding: "1rem 0",
                    pr: { xs: 2, sm: 6 },
                    position: "relative",
                    right: { xs: 0, sm: 80, md: 200 },
                }}
            >
                <a href="https://www.linkedin.com/company/esiprosrl/posts/?feedView=all" target="_blank" rel="noopener noreferrer" className="contatti-social-link">
                    <svg viewBox="0 0 24 24" width="20" height="20" fill="#fff">
                        <path d="M4.98 3.5C4.98 4.881 3.87 6 2.5 6S.02 4.881.02 3.5C.02 2.12 1.13 1 2.5 1s2.48 1.12 2.48 2.5zM5 8H0v16h5V8zm7.982 0H8.014v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0V24H24V13.869c0-7.88-8.922-7.593-11.018-3.714V8z"/>
                    </svg>
                </a>
            </Box>

            {mapOpen && (
                <div className="map-modal-overlay" onClick={() => setMapOpen(false)}>
                    <div className="map-modal" onClick={(e) => e.stopPropagation()}>
                        <button className="map-modal-close" onClick={() => setMapOpen(false)} aria-label={t('contacts.closeLabel')}>
                            &times;
                        </button>
                        <div className="map-modal-header">
                            <h2 className="map-modal-title">{t('contacts.mapTitle')}</h2>
                            <div className="map-modal-subtitle">{address}</div>
                        </div>
                        <div className="map-modal-frame">
                            <iframe
                                title={t('contacts.mapIframeTitle')}
                                src={mapSrc}
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                style={{ border: 0, width: '100%', height: '100%' }}
                                allowFullScreen
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
